import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import './Login.css';

const Login = () => {
  const { signInWithGoogle, loading, bypassAuth, testUsers, shouldAutoBypass, authError, clearAuthError } = useAuth();
  const [selectedTestUser, setSelectedTestUser] = useState('');

  const handleGoogleLogin = async () => {
    try {
      // If auto-bypass is enabled (staging + bypass auth), use the first staging test user
      if (shouldAutoBypass && testUsers?.length > 0) {
        await signInWithGoogle(testUsers[0].email);
        return;
      }
      // Pass selected test user email (could be empty string if not selected)
      await signInWithGoogle(selectedTestUser);
    } catch (error) {
      console.error('Login error:', error);
    }
  };

  return (
    <div className="login-container">
      <main className="login-main">
        {/* Header */}
        <header className="login-header">
          <div className="header-content">
            <div className="header-brand">
              <img src="/genentech-logo.svg" alt="Genentech Logo" />
            </div>
            <span className="header-divider"></span>
            <div className="header-title">
              <span className="header-icon">
                <img src="/builder-icon.svg" />
              </span>
              <span>Conference Quick Guide Builder</span>
            </div>
          </div>
        </header>

        {/* Login Card */}
        <div className="login-card">
          <div className='login-wrapper'>
          </div>
          <h2>Welcome Back</h2>
          <p className="login-subtitle">Sign in to continue to Quick Guide</p>

          {/* Error Message */}
          {authError && (
            <div className="login-error">
              <span className="login-error-icon">!</span>
              <span className="login-error-message">{authError}</span>
              <button className="login-error-close" onClick={clearAuthError} aria-label="Dismiss error">&times;</button>
            </div>
          )}

          {/* Test User Dropdown - Only shown when REACT_APP_BYPASS_AUTH=true and NOT on staging */}
          {bypassAuth && testUsers && !shouldAutoBypass && (
            <div className="test-user-section">
              <label className="test-user-label">Select Test User</label>
              <select
                className="test-user-dropdown"
                value={selectedTestUser}
                onChange={(e) => setSelectedTestUser(e.target.value)}
              >
                <option value="">-- Select a test user --</option>
                {testUsers.map((user) => (
                  <option key={user.email} value={user.email}>
                    {user.name} ({user.email})
                  </option>
                ))}
              </select>
            </div>
          )}

          <button
            className="google-login-btn"
            onClick={handleGoogleLogin}
            disabled={loading}
          >
            {loading ? (
              <span className="spinner"></span>
            ) : (
              <>
                <svg className="google-icon" viewBox="0 0 24 24">
                  <path
                    fill="#4285F4"
                    d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                  />
                  <path
                    fill="#34A853"
                    d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                  />
                  <path
                    fill="#FBBC05"
                    d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                  />
                  <path
                    fill="#EA4335"
                    d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                  />
                </svg>
                Continue with Google
              </>
            )}
          </button>

          <p className="login-footer-text">
            By signing in, you agree to our Terms of Service and Privacy Policy
          </p>
        </div>
      </main>
    </div>
  );
};

export default Login;
